import './Page.css';

export default function About() {
  return (
    <div className="page">
      <h1>About Us</h1>
      <p>
        First Gradient is a specialized consulting firm focused on High Performance Computing
        in the cloud. We partner with engineering teams to accelerate their computational
        workloads using AWS infrastructure.
      </p>
      <p>
        Our team brings deep expertise in HPC cluster design, parallel computing, job scheduling,
        and cost optimization. Whether you're running CFD simulations, finite element analysis,
        or large-scale data processing, we help you get results faster.
      </p>
      <h2>Why First Gradient?</h2>
      <ul>
        <li>Deep AWS HPC expertise including ParallelCluster and Engineering Development Hub</li>
        <li>Proven track record with simulation-heavy engineering organizations</li>
        <li>End-to-end support from architecture through production operations</li>
      </ul>
    </div>
  );
}
